import { render, staticRenderFns } from "./RecordLanguageEditor.vue?vue&type=template&id=5b461c68&scoped=true"
import script from "./RecordLanguageEditor.vue?vue&type=script&lang=js"
export * from "./RecordLanguageEditor.vue?vue&type=script&lang=js"
import style0 from "./RecordLanguageEditor.vue?vue&type=style&index=0&id=5b461c68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b461c68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VCheckbox,VProgressLinear,VSelect,VTextField})
